import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function RishikeshLuxuryroom() {
    const heading = "Deluxe";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Rishikesh Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-rishikesh/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Deluxe",
            },
        ]
    }

    const roomBanner = {
        image: "/image/rishikesh-deluxe-room-detail.webp",
    };

    const roomQuote = {
        content: "Perfect for couples, solo travellers, and short leisure breaks, the Deluxe Room provides everything you need for a pleasant stay. After a day of yoga, sightseeing, or riverside adventures, return to a peaceful retreat designed to help you rest and recharge.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1 King",
        area: "21",
        bathroom: "1",
        guest: "2",
        balcony: "0",
        viewLabel: "No View"
    };

    const roomGallery = [
        { image: "/image/rishikesh-deluxe-room-gallery-1.webp" },
        { image: "/image/rishikesh-deluxe-room-gallery-2.webp" },
        { image: "/image/rishikesh-deluxe-room-gallery-3.webp" },
        { image: "/image/rishikesh-deluxe-room-gallery-4.webp" },

    ];

    const roomEquipment = {
        description: "Step into a relaxing space where comfortable interiors and modern amenities come together to create an enjoyable stay.",
        equipment: [
        [
            "Premium Pocketed Spring Mattress",
            "Air Conditioning",
            "Complimentary High-Speed Wi-Fi",
            "Smart TV for Entertainment",
        ],
        [
            "Tea & Coffee Maker with Daily Replenishment",
            "Mini Bar for Refreshments",
            "Electronic In-Room Safe",
            "Writing Desk with Comfortable Chair",
        ],
        [
            "Hydropneumatic Shower with 24-Hour Hot Water",
            "Soft Cotton Linens and Plush Duvet",
            "Iron & Ironing Board",
            "Bathrobe & Slippers",
        ]
    ]
    };

    const roomBook = {
        location: "Rishikesh",
        title: "Deluxe",
        desc: "Unwind in the inviting Deluxe Room at De Coracao, thoughtfully designed for a comfortable and restful stay. With a plush king bed, modern amenities, and a peaceful ambience, it offers a welcoming retreat between adventures, sightseeing, and moments of relaxation.",
        details: [
            " 1 King Size Bed",
            "Up to 2 Guests",
            "21 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="
    };


    const otherRoom = {
        slides: [
            {
                title: 'Super Deluxe',
                bg: '/image/rishikesh-super-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/super-deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "26 sq.mt",
                ],
            },

            {
                title: 'Suite',
                bg: '/image/rishikesh-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "33 sq.mt",
                ],
            },

            {
                title: 'Premium Suite',
                 bg: '/image/rishikesh-premium-suite-inner.webp',
                slug: '/resort-de-coracao-rishikesh/premium-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },

            {
                 title: 'Ganga Suite',
                bg: '/image/rishikesh-ganga-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/ganga-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },
           
        ],

        allRoom: { link: "/resort-de-coracao-rishikesh/room-listing" }
    }

    return (
        <> 
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
